//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import create from "../../create";
export default create({
  name: "swiper",
  data: function data() {
    return {
      typeList: {
        img: /\.(gif|jpg|jpeg|png|GIF|JPG|PNG)/,
        video: /\.(swf|avi|flv|mpg|rm|mov|wav|asf|3gp|mkv|rmvb|ogg|mp4)/
      }
    };
  },
  computed: {
    hlsOption: function hlsOption() {
      return {
        autoplay: this.option.autoplay
      };
    },
    params: function params() {
      var result = {};
      if (this.option.controls) result.controls = "controls";
      if (this.option.loop) result.loop = "loop";
      if (this.option.autoplay) result.autoplay = "autoplay";
      return result;
    },
    styleName: function styleName() {
      return {
        width: '100%',
        height: '100%',
        opacity: this.opacity
      };
    },
    indicator: function indicator() {
      return this.opacity.indicator || "none";
    },
    opacity: function opacity() {
      return (this.option.opacity || 100) * 0.01;
    },
    type: function type() {
      return this.option.type || "";
    },
    interval: function interval() {
      return this.option.interval || 5000;
    }
  },
  created: function created() {},
  mounted: function mounted() {},
  methods: {
    handleClick: function handleClick(item, index) {
      this.clickFormatter && this.clickFormatter({
        type: index,
        item: item,
        value: item.value,
        data: this.dataChart
      }, this.getItemRefs());
    }
  },
  props: {
    option: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  }
});